import i18n from "i18next";
import detector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import enTranslation from "./assets/locales/en.json";
import jaTranslation from "./assets/locales/jp.json";
import koTranslation from "./assets/locales/ko.json";

import { DOMAIN, PREVIEW_DOMAIN } from "@const/urls";

const lang = localStorage.getItem("i18nextLng");
let newLang = "ko";

if (window.location.href.includes("localhost") || window.location.hostname.includes("ngrok")) {
  newLang = lang ? lang : newLang;
} else {
  if (window.location.href.includes(DOMAIN.ko) || window.location.href.includes(PREVIEW_DOMAIN.ko)) {
    newLang = "ko";
  }

  if (window.location.href.includes(DOMAIN.en) || window.location.href.includes(PREVIEW_DOMAIN.en)) {
    newLang = "en";
  }

  if (window.location.href.includes(DOMAIN.jp) || window.location.href.includes(PREVIEW_DOMAIN.jp)) {
    newLang = "jp";
  }
}

i18n
  .use(detector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  .init({
    debug: false,
    lng: newLang,
    fallbackLng: ["ko", "en"],
    detection: {
      order: ["subdomain"],
      lookupFromSubdomainIndex: 0,
    },
    interpolation: { escapeValue: false },
    resources: {
      en: { translation: enTranslation },
      ko: { translation: koTranslation },
      jp: { translation: jaTranslation },
    },
    react: { useSuspense: true },
  });

export default i18n;
